module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-inline-flex align-items-center"
  }, [(_vm.icon) ? _c('span', {
    class: ("container-icon-description " + _vm.icon)
  }, [_c('span', {
    class: ("sprite-icons " + _vm.icon)
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "key-description"
  }, [_vm._v(_vm._s(_vm.label) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "value-description"
  }, [_vm._v(_vm._s(_vm.description))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3133e480","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/DetailDescription.vue
// module id = 942
// module chunks = 33 38 39 40 41 42 43 44 49